import { useEffect } from 'react';

import type { UseAddEditInventoryEffectsProps } from '@app/pages/Warehouses/Inventory/components/AddEditInventory/types';

export const useAddEditInventoryEffects = ({
  inventoryDataHandler,
}: UseAddEditInventoryEffectsProps) => {
  useEffect(() => {
    inventoryDataHandler();
  }, [inventoryDataHandler]);
};
